/**
 * Возвращает слово в нужном падеже в зависимости от числа (1 единица, 2 единицы, 5 единиц).
 * @param {number} number - число
 * @param {[string, string, string]} wordForms - формы слова в нужных падежах (e.g. [единица, единицы, единиц])
 */
export default function filterCase(number: number, wordForms: [string, string, string]) {
  const absHundredRemainder = Math.abs(number) % 100
  const tenRemainder = absHundredRemainder % 10

  if (absHundredRemainder > 10 && absHundredRemainder < 20) {
    return wordForms[2]
  }

  if (tenRemainder > 1 && tenRemainder < 5) {
    return wordForms[1]
  }

  if (tenRemainder === 1) {
    return wordForms[0]
  }

  return wordForms[2]
}
